import React from 'react';
import p from 'translation';
import { App } from 'core/types/app';

import { ReactComponent as PeopleIcon } from './img/people.svg';
import { ReactComponent as KompsIcon } from './img/komps.svg';
import { ReactComponent as GroupsIcon } from './img/groups.svg';
import { ReactComponent as SettingsIcon } from './img/settings.svg';
import { ReactComponent as AnalyticsIcon } from './img/chart.svg';
import icon from './icon.svg';

const manage: App = {
  id: 'manage',
  name: p.t('apps.manage.name'),
  icon,
  color: {
    main: '#0064C9',
    light: '#5B91FD',
    dark: '#003B97',
    contrastText: '#fff',
  },
  app: React.lazy(() => import(/* webpackChunkName: "manage" */ './app')),
  navigation: [
    {
      title: p.t('components.main-navigation.komps'),
      path: '/',
      hasAccess: () => true,
      icon: <KompsIcon />,
      forceActive: (): boolean =>
        window.location.pathname.includes('/app/manage/info'),
    },
    {
      title: p.t('apps.manage.users.title'),
      path: '/people',
      hasAccess: () => true,
      icon: <PeopleIcon />,
      forceActive: (): boolean =>
        window.location.pathname.includes('/app/manage/profile') ||
        window.location.pathname.includes('/app/manage/people'),
    },
    {
      title: p.t('apps.manage.groups.title'),
      path: '/groups',
      icon: <GroupsIcon />,
      hasAccess: () => true,
      forceActive: (): boolean =>
        window.location.pathname.includes('/app/manage/group'),
    },
    {
      title: p.t('apps.manage.settings.title'),
      path: '/settings',
      icon: <SettingsIcon />,
      hasAccess: () => true,
    },
    {
      title: 'Analytics',
      path: '/analytics',
      icon: <AnalyticsIcon />,
      hasAccess: () => true,
    },
  ],
};

export default manage;
